import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > div": {
      top: 0,
      paddingBottom: theme.hv.spacing.lg,
    },
  },
  form: {
    marginLeft: "0%",
    flexBasis: "calc(66.666667% + 60px)",
    maxWidth: "unset",
  },
  icon: {
    position: "fixed",
    marginTop: "20px",
    marginLeft: "37px",
    zIndex: 1099,
  },
  userIcon: {
    position: "fixed",
    marginTop: "18px",
    marginLeft: "39px",
    zIndex: 1099,
  },
  sectionMargin: {
    marginTop: theme.hv.spacing.md,
    outline: "none",
  },
  loading: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100vh",
  },
  zIndex: {
    // We need to set this nonsense value to make sure the loading overlays all HVS page elements.
    zIndex: 9999999999,
  },
  title: {
    ...theme.hv.typography.xsTitle,
  },
  formHeaderIcon: {
    height: 32,
    width: 32,
    marginRight: theme.hv.spacing.xs,
    padding: "8px 6px",
    fontSize: 17,
    textAlign: "center",
  },
  firstLastColumn: {
    flexBasis: "calc(16.666667% - 30px)",
  },
}));

export default useStyles;
